import $ from "jquery";

export function initAddToCart() {

    $(document).on('click', '[data-add-to-cart-delivery]', function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        handleAddToCart(button);
    })

    $(document).on('click', '[data-add-to-cart-click-and-collect]', function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        handleAddToCart(button);
    })
    
}


function handleAddToCart(button) {
    const url = button.data('add-to-cart-url');
    const context = button.parents('[data-add-to-cart-context]');
    const variantId = context.find('[data-add-to-cart-id]').val();
    const quantity = context.find('[data-add-to-cart-quantity]').val();
    const branchId = context.find('[data-add-to-cart-branch-id]').val();

    $.post(
        url,
        {
            variantId: variantId,
            quantity: quantity,
            branchId : branchId ?? undefined
        },
        function (response) {
            if (response.success) {
                window.location.href = response.redirectUrl
            } else {
                alert(response.message);
            }
        },
        'json'
    );
}
